import { render } from "./Price.vue?vue&type=template&id=f41b440c&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "./Price.vue?vue&type=style&index=0&id=f41b440c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f41b440c"

export default script